import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    props: true,
    component: () =>
      import(/* webpackChunkName: "conversation" */ "../views/LoginView.vue"),
  },
  {
    path: "/",
    name: "home",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "HomeView" */ "../views/HomeView.vue"),
    children: [
      {
        path: "/configs",
        name: "configs",
        component: () =>
          import(
            /* webpackChunkName: "project-configs" */ "../views/ProjectConfigs/ProjectConfigsIndex.vue"
          ),
        meta: { requiresAuth: true },
        redirect: { name: "profile" },
        children: [
          {
            path: "profile",
            name: "profile",
            component: () =>
              import(
                /* webpackChunkName: "organization" */ "../views/ProjectConfigs/OrganizationView.vue"
              ),
          },
          {
            path: "tags",
            name: "tags",
            component: () =>
              import(
                /* webpackChunkName: "tags" */ "../views/ProjectConfigs/ReportTags.vue"
              ),
          },
          {
            path: "users",
            name: "users",
            component: () =>
              import(
                /* webpackChunkName: "users" */ "../views/ProjectConfigs/OrganizationUsers.vue"
              ),
          },
        ],
      },
      {
        path: "conversation/:conversationId",
        name: "conversation",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "conversation" */ "../views/ConversationView.vue"
          ),
        meta: { requiresAuth: true },
      },
      {
        path: "compare",
        name: "compare",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "conversation" */ "../views/CompareView.vue"
          ),
        meta: { requiresAuth: true },
      },
      {
        path: "reports",
        name: "reports",
        props: true,
        component: () =>
          import(/* webpackChunkName: "reports" */ "../views/ReportsView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "playground",
        name: "playground",
        component: () =>
          import(
            /* webpackChunkName: "playground" */ "../views/PlayGround.vue"
          ),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/reports/:reportId",
    name: "reports-item",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "reports-item" */ "../views/ReportsItemView.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
